/**
 * Shown wherever a person's audience group is displayed to that person.
 */
export const AUDIENCE_GROUP_DESCRIPTION =
  'Your audience group is assigned automatically based on your role at the GSD and ' +
  'influences the content and features available to you in GSD Now.';
